<template>
    <div class="login-container">
        <div class="login-content">
            <div class="login-form" v-if="isVerifyLogin">
                <div class="login-logo">
                    <img class="login-logo_img" :src="logo" alt="">
                    <div>
                        <span class="login-name">幼学记</span>
                        <span class="login-des">家校链接新方式</span>
                    </div>
                </div>
                <a-input class="login-input" v-model="loginForm.mobile" placeholder="请输入手机号" />
                <a-input class="login-input" v-model="loginForm.code" placeholder="请输入验证码" @pressEnter="loginHandle" />
                <div class="clearfix">
                    <span class="login-register" @click="toResieterHandle">注册</span>
                    <span class="login-register fr" @click="changeHandle">切换手机号/密码登录</span>
                </div>
                <div class="login-verify" @click="getVerifyHandel">{{ isSending ? time : "发送验证码" }}</div>
                <a-button class="submit-btn" @click="loginHandle">确定</a-button>
            </div>
            <div class="login-form" v-else>
                <div class="login-logo">
                    <img class="login-logo_img" :src="logo" alt="">
                    <div>
                        <span class="login-name">幼学记</span>
                        <span class="login-des">家校链接新方式</span>
                    </div>
                </div>
                <a-input class="login-input" v-model="loginForm.mobile" placeholder="请输入手机号" />
                <a-input class="login-input" type="password" v-model="loginForm.password" placeholder="请输入密码" @pressEnter="loginHandle" />
                <div class="clearfix">
                    <span class="login-register" @click="toResieterHandle">注册</span>
                    <span class="login-register fr" @click="changeHandle">切换手机号/验证码登录</span>
                </div>
                <a-button class="submit-btn" @click="loginHandle">确定</a-button>
            </div>
        </div>
    </div>
</template>
    
<script>
import { mapGetters } from "vuex";
import logo from "@/assets/images/login_logo.png";
import userService from "@/api/userService";

export default {
    name: "login",
    components: {},
    data() {
        return {
            logo,
            loginForm: {
                mobile: undefined,
                code: undefined,
                password: undefined,
            },
            isVerifyLogin: true,
            isSending: false,
            timer: null,
            time: 60,
            messageId: null,
        }
    },
	computed: {
		...mapGetters(["hasTeacherRole", "isManager"]),
	},

    methods: {
        toResieterHandle() {
            this.$router.push({ name: "register" });
        },

        changeHandle() {
            this.isVerifyLogin = !this.isVerifyLogin;
        },

        getVerifyHandel() {
            if (!this.loginForm.mobile || this.loginForm.mobile.trim().length !== 11) {
                this.$message.warning("请输入合法的手机号");
                return;
            }
            if (this.isSending) return;
            this.isSending = true;
            userService.getVerifyCodeService({ mobile: this.loginForm.mobile.trim() }).then(res => {
                this.messageId = res.message_id;
                this.timeCountHandle();
            }).catch(() => {
                this.isSending = false;
            });
        },

        timeCountHandle() {
            this.timer = setTimeout(() => {
                let time = this.time - 1;
                if (time < 1) {
                    clearTimeout(this.timer);
                    this.isSending = false;
                    this.time = 60;
                } else {
                    this.time = time;
                    this.timeCountHandle();
                }
            }, 1000);
        },

        loginHandle() {
            const { mobile, code, password } = this.loginForm;
            if (!mobile || mobile.trim().length !== 11) {
                this.$message.warning("请输入合法的手机号");
                return;
            }

            if (this.isVerifyLogin) {
                if (!this.messageId) {
                    this.$message.warning("请先获取验证码");
                    return;
                }

                if (!code || code.trim().length !== 6) {
                    this.$message.warning("请输入合法的验证码");
                    return;
                }

                this.$store.dispatch("loginWithCodeService", {
                    mobile: mobile.trim(),
                    verification_code: code.trim(),
                    verification_message_id: this.messageId
                }).then(() => {
                    this.$store.dispatch("getUserInfoService");
                    this.getTeacherInfo();
                }).catch((err) => {
                    this.isSending = false;
                    const detail = err && err.response && err.response.data && err.response.data.detail;
                    const error = err && err.response && err.response.data && err.response.data.error;
                    const operator = err && err.response && err.response.data && err.response.data.operator;
                    const statusCode = err && err.response && err.response.status;
                    if (detail === "invalid credential" && statusCode === 401) {
                        this.$message.error("当前手机号尚未注册，请先注册");
                    } else if (error === "Not Allowed" && operator === "code_verification") {
                        this.$message.error("您输入的验证码异常，请输入正确的验证码");
                    } else {
                        this.$message.error("登录异常");
                    }
                });
                return;
            }

            if (!password || !password.trim().length) {
                this.$message.warning("请输入密码");
                return;
            }

            this.$store.dispatch("loginService", {
                username: mobile.trim(),
                password: password.trim(),
            }).then(() => {
                this.$store.dispatch("getUserInfoService");
                this.getTeacherInfo();
            }).catch((err) => {
                this.isSending = false;
                const detail = err && err.response && err.response.data && err.response.data.detail;
                const statusCode = err && err.response && err.response.status;
                if (detail === "invalid credential" && statusCode === 401) {
                    this.$message.error("手机号码或者密码不正确");
                } else {
                    this.$message.error("登录异常");
                }
            });
        },

        getTeacherInfo() {
            this.$store.dispatch("getTeacherInfoMineListService").then((res = []) => {
                if (!res.length) {
                    this.$router.push({ name: "notPermission" });
                } else if (this.isManager || this.hasTeacherRole) {
                    this.$router.push({ name: "school" });
                } else {
                    this.$router.push({ name: "external" });
                }
            }).catch(() => {
                this.isSending = false;
            });
        },
    }
}
</script>

<style lang="less" scoped>
.login {
    &-container {
        position: relative;
        height: 100vh;
        background: url("../../assets/images/login_bg.png") no-repeat 0 0;
        background-size: 100% 100%;
    }

    &-content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1070px;
        height: 658px;
        padding-left: 534px;
        border-radius: 16px;
        background: #FFFFFF url("../../assets/images/login_content_bg.png") no-repeat 33px 125px;
        background-size: 447px 407px;
    }

    &-form {
        position: relative;
        width: 437px;
        height: 544px;
        margin-top: 54px;
        padding: 60px 35px 0;
        border-radius: 4px;
        opacity: 1;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    }

    &-logo {
        display: flex;
        flex-flow: nowrap row;
        align-items: center;
        justify-content: center;
        margin-bottom: 54px;

        &_img {
            width: 63px;
            margin: 5px 10px 0 0;
        }
    }

    &-name {
        display: block;
        height: 42px;
        margin-bottom: 5px;
        font-size: 32px;
        color: #343C6A;
    }

    &-des {
        display: block;
        height: 20px;
        font-size: 14px;
        color: #343C6A;
    }

    &-input {
        display: block;
        margin: 0 auto 20px;
        width: 368px;
        height: 56px;
        border-radius: 8px;
        border: 1px solid #D6D6D6;
    }

    &-verify {
        position: absolute;
        right: 35px;
        top: 258px;
        width: 100px;
        height: 56px;
        line-height: 56px;
        cursor: pointer;
        color: #01ACFC;
        text-align: center;
    }

    &-register {
        font-size: 14px;
        color: #01ACFC;
        cursor: pointer;
    }

    &-btn {
        display: block;
        width: 370px;
        height: 56px;
        margin: 85px auto 0;
        border-radius: 8px;
        background: linear-gradient(270deg, #04B2FA -10%, #037CFE 28%, #0169FC 101%);
        color: #FFFFFF;

        &:hover {
            background: linear-gradient(270deg, #04B2FA -10%, #037CFE 28%, #0169FC 101%);
            color: #FFFFFF;
        }

        &:active {
            background: linear-gradient(270deg, #04B2FA -10%, #037CFE 28%, #0169FC 101%);
            color: #FFFFFF;
        }
    }
}
</style>
    